module.exports = __webpack_public_path__ + "img/16-10.d3449cc9.png";